<template>
  <sidebar-item-body class="pc-note__outline" name="outline">
    <div class="pc-loading" v-if="isLoading">
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>
    <outline-item :data="outline" :isRoot="true" v-else/>
  </sidebar-item-body>
</template>

<script>
import { mapGetters } from 'vuex'
import OutlineItem from '@/components/note/sidebar/OutlineItem.vue'
import SidebarItemBody from '@/components/note/sidebar/SidebarItemBody.vue'

export default {
  components: {
    OutlineItem,
    SidebarItemBody
  },
  computed: {
    ...mapGetters('workbench/outline', {
      outline: 'outline'
    }),
    ...mapGetters('workbench/current', {
      isLoading: 'noteLoading'
    })
  }
}
</script>
